export default __webpack_public_path__ + "static/woman-6d1089f0967b1ce4f19339f6ced6f52d.png";